<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Usuario</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Usuario</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Rol}}</mat-label>
                        <mat-select [compareWith]="compareIdentityRoles" formControlName="rol"
                            (selectionChange)="selectRol($event.value)">

                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let i of identityRoles" [value]="i">{{i.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(form.get('rol').hasError('required')) && form.get('rol').touched ">
                            {{Validaciones.Rol}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div [hidden]='!multiSelectDivisiones || hiddenSelectDivisiones'>


                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Pais}}</mat-label>
                            <mat-select #multi [compareWith]="comparePaises"
                                (selectionChange)="selectMultiPais($event.value)" [formControl]="formControlMultiPais"
                                multiple>

                                <mat-option *ngFor="let p of paises" [value]="p">{{p.descripcion}}
                                </mat-option>
                            </mat-select>

                            <mat-error
                                *ngIf="(form.get('paises').hasError('required')) && form.get('paises').touched ">
                                {{Validaciones.Pais}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div [hidden]='multiSelectDivisiones || hiddenSelectDivisiones'>
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Pais}}</mat-label>
                            <mat-select #single [compareWith]="comparePaises"
                                (selectionChange)="selectSinglePais($event.value)"
                                [formControl]="formControlSinglePais">
                                <mat-option [value]="-1">- Seleccione -</mat-option>

                                <mat-option *ngFor="let p of paises" [value]="p">{{p.descripcion}}
                                </mat-option>
                            </mat-select>

                            <mat-error
                                *ngIf="(form.get('paises').hasError('required')) && form.get('paises').touched ">
                                {{Validaciones.Pais}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div [hidden]='!multiSelectDivisiones || hiddenSelectDivisiones'>


                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Division}}</mat-label>
                            <mat-select #multi [compareWith]="compareDivisiones"
                                (selectionChange)="selectMultiDivision($event.value)"
                                [formControl]="formControlMultiDivision" multiple>

                                <mat-option *ngFor="let d of divisiones" [value]="d">{{d.displayValue}}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="!divisiones.length">(Seleccioná un pais)</mat-hint>
                            <mat-error
                                *ngIf="(form.get('divisiones').hasError('required')) && form.get('divisiones').touched ">
                                {{Validaciones.Division}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div [hidden]='multiSelectDivisiones || hiddenSelectDivisiones'>
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Division}}</mat-label>
                            <mat-select #single [compareWith]="compareDivisiones"
                                (selectionChange)="selectSingleDivision($event.value)"
                                [formControl]="formControlSingleDivision">
                                <mat-option [value]="-1">- Seleccione -</mat-option>
                                <mat-option *ngFor="let d of divisiones" [value]="d">{{d.displayValue}}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="!divisiones.length">(Seleccioná un pais)</mat-hint>
                            <mat-error
                                *ngIf="(form.get('divisiones').hasError('required')) && form.get('divisiones').touched ">
                                {{Validaciones.Division}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>




                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div *ngIf='selectRegiones'>
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Region}}</mat-label>
                            <mat-select [compareWith]="compareRegiones" formControlName="region"
                                (selectionChange)="selectRegion($event.value)">
                                <mat-option [value]="-1">- Seleccione -</mat-option>
                                <mat-option *ngFor="let r of regiones" [value]="r">{{r.displayValue}}
                                </mat-option>
                            </mat-select>
                            <mat-hint *ngIf="!regiones.length">(Seleccioná un pais)</mat-hint>
                            <mat-error
                                *ngIf="(form.get('region').hasError('required')) && form.get('region').touched ">
                                {{Validaciones.Region}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline" *ngIf="idTipo ==1">
                        <mat-label>{{Etiquetas.UserName}}</mat-label>
                        <input type="text" matInput formControlName="userName">
                        <button *ngIf="idTipo === 1 && !isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('userName')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('userName').hasError('required') || form.get('userName').hasError('email')) && form.get('userName').touched ">
                            {{Validaciones.UserName}}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field color="accent-darker" class="readonly-form-field" appearance="outline"
                        *ngIf="idTipo !=1">
                        <mat-label>{{Etiquetas.UserName}}</mat-label>
                        <input type="text" matInput readonly formControlName="userName">
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Email}}</mat-label>
                        <input type="email" matInput formControlName="email" placeholder="Ejemplo@bayer.com">
                        <button *ngIf="idTipo === 1 && !isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('email')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('email').hasError('required') || form.get('email').hasError('email')) && form.get('email').touched ">
                            {{Validaciones.Email}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Nombre}}</mat-label>
                        <input type="text" matInput formControlName="nombre">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('nombre')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        <mat-error
                            *ngIf="(form.get('nombre').hasError('required') || form.get('nombre').hasError('maxLength')) && form.get('nombre').touched ">
                            {{Validaciones.Nombre}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Apellido}}</mat-label>
                        <input type="text" matInput formControlName="apellido">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('apellido')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        <mat-error
                            *ngIf="(form.get('apellido').hasError('required') || form.get('apellido').hasError('maxLength')) && form.get('apellido').touched ">
                            {{Validaciones.Apellido}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="emailConfirmado" color="primary-darker">
                        {{Etiquetas.EmailConfirmado}}
                    </mat-checkbox>

                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="bloqueado" color="primary-darker">
                        {{Etiquetas.Bloqueado}}
                    </mat-checkbox>

                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="habilitacion" color="primary-darker">
                        {{Etiquetas.Habilitacion}}
                    </mat-checkbox>

                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="recibeMailAutorizacion" color="primary-darker">
                        {{Etiquetas.RecibeMailAutorizacion}}
                    </mat-checkbox>

                </div>
            </div>
        </div>


    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" [disabled]="form.invalid" (click)="guardarUsuario(true)"
        mat-flat-button color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>